export default __webpack_public_path__ + "static/media/TSB.9b2f4f0e.svg";